import Ajv from "ajv";
import * as roiParamSchema from "types/ToolRoiFrameParamValue/ToolRoiFrameParamValue.json";
import { ToolRoiFrameParamValue } from "./ToolRoiFrameParamValue";

const ajv = new Ajv();

export const isToolRoiFrameParamValue =
  ajv.compile<ToolRoiFrameParamValue>(roiParamSchema);
